<template>
  <div class="container">
    <!-- <pre>{{imgList}}</pre> -->
    <div class="swiper-img">
      <van-swipe @change="onChange" :stop-propagation="false">
        <van-swipe-item v-for="(item, index) in imgList" :key="index">
          <div class="img">
            <van-image
              v-if="item.valueType != 1"
              fit="cover"
              :src="item.value"
              @click="lookAllsw(item)"
            />
            <van-image
              v-else
              fit="cover"
              :src="item.poster"
              @click="lookAllsw(item)"
            />
            <div
              class="play plays"
              v-if="item.valueType == 1"
              @click="lookAllsw(item)"
            >
              <img src="../../assets/newReport/play.png" alt />
            </div>
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator" style="color: #ffffff">
            {{ current + 1 }}/{{ imgList.length }}
          </div>
        </template>
      </van-swipe>
    </div>
    <div class="main">
      <!-- 车辆标题 -->
      <div class="carmsg">
        <div class="carName">
          <div class>{{ titleInfo.title }}</div>
          <div class="vin">整备基准日：{{ titleInfo.prepDate }}</div>
        </div>
      </div>
      <div class="specialTip">
        <div class="carImgTitle c-p">特殊事项说明</div>
        <div class="sp-tips" v-if="titleInfo.special">
          {{ titleInfo.special }}
        </div>
        <div class="sp-tips" v-if="!titleInfo.special">-</div>
      </div>
      <!-- 评估师 -->
      <div class="appraiser" @click="jumpEav">
        <div class="logo">
          <div class="pops">整备人员：</div>
          <van-image fit="cover" :src="titleInfo.avatarUrl" />
          <div class="a-name">{{ titleInfo.name }}</div>
        </div>
        <div class="a-title-img">
          <!-- <div class="a-title" v-if="titleInfo.levelId == 1">
            <img
              src="https://vehicle-library.oss-cn-beijing.aliyuncs.com/cvbd-icon/evaluation_intermediate.png"
              alt
            />
            <div class="a-name ans">商用车鉴定评估师 初级</div>
          </div> -->
          <div class="a-title">
            <img
              src="https://vehicle-library.oss-cn-beijing.aliyuncs.com/cvbd-icon/evaluation_intermediate.png"
              alt
            />
            <div class="a-name ans">
              商用车鉴定评估师 {{ titleInfo.levelDesc }}
            </div>
          </div>
          <!-- <div class="a-title" v-if="titleInfo.levelId == 3">
            <img
              src="https://vehicle-library.oss-cn-beijing.aliyuncs.com/cvbd-icon/evaluation_intermediate.png"
              alt
            />
            <div class="a-name ans">商用车鉴定评估师 高级</div>
          </div> -->
          <img class="a-link" src="../../assets/report/arrow.png" alt />
        </div>
      </div>
      <!-- 车辆信息 -->
      <div class="appInfo">
        <div class="carMoreInfo">车辆信息</div>
        <ul class="app-list">
          <li class="app-item" v-for="(item, index) in carMessage" :key="index">
            <div
              v-if="item.name == '未接受处理的交通违法记录(条)'"
              style="width: 210px"
            >
              {{ item.name }}
            </div>
            <div v-else>{{ item.name }}</div>
            <div v-if="item.value == 0 || item.value">{{ item.value }}</div>
            <div v-else>-</div>
          </li>
          <li
            class="app-item app-item-f"
            v-for="(item, index) in paramsList"
            :key="index"
          >
            <div>{{ item.name }}</div>
            <div v-if="item.value">{{ item.value }}</div>
            <div v-else>-</div>
          </li>
        </ul>
        <div class="lookMsg" @click="jumpInfo">查看更多车辆信息</div>
      </div>
      <!-- 车辆报告 -->
      <div class="car-report">
        <div class="carImgTitle c-p">整备结果</div>
        <ul class="report-list">
          <li
            @click="jumpReport(index)"
            v-for="(item, index) in reportInfo"
            :key="index"
          >
            <div class="report-names">
              <div>{{ item.name }}({{ item.defectNum }}项)</div>
              <div class="restore">
                <div v-if="item.num" class="restore-num">{{ item.num }}项</div>
                <div v-else style="color: #999999">0项</div>
                <van-icon name="arrow" />
              </div>
            </div>
          </li>
        </ul>
        <div class="lookMsg look-report lookMsgss" @click="jumpReport('无')">
          查看详细报告
        </div>
      </div>
    </div>
    <!-- 车辆图片 -->
    <div class="carImg">
      <div class="carImgTitle">车辆相关图片</div>
      <div class="cag-c">
        <div class="imgSwiper" v-for="(item, index) in list" :key="index">
          <ul class="carimg-nav" @click="lookAlls(item, index)">
            <li>{{ item.title }}</li>
            <li class="ca-more">
              查看更多
              <van-icon name="arrow" />
            </li>
          </ul>
          <ul ref="imgList" class="carI-list">
            <li v-for="(ite, ind) in item.imgList" :key="ind">
              <van-image
                v-if="ite.valueType != 1"
                fit="cover"
                :src="ite.value"
                @click="lookAllsw(ite)"
              />
              <van-image
                v-else
                fit="cover"
                :src="ite.poster"
                @click="lookAllsw(ite)"
              />
              <div
                class="play"
                v-if="ite.valueType == 1"
                @click="lookAllsw(ite)"
              >
                <img src="../../assets/newReport/play.png" alt />
              </div>
              <div class="imgName">{{ ite.name }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bottoms">
      <div class="b-title">承诺质保期</div>
      <div class="b-tip">
        自购车之日起，本车辆以下部件在满足质保条件下，本公司实行质量保修。
      </div>
      <div class="b-tip">
        注：对于质保期的时间或里程数均有限定的，以先到的为准。
      </div>
      <div v-if="proList.length">
        <div v-for="(item, index) in proList" :key="index">
          <div class="zhibao">
            <div>
              <div class="zhibw">质保项{{ index + 1 }}:</div>
              <div>{{ item.name }}</div>
            </div>
            <div class="tiaojian">
              <div class="zhibw">条件1</div>
              <div class="zhibv">时限{{ item.value1 }}天以内</div>
            </div>
            <div class="tiaojian tiaojian1" v-if="item.value2">
              <div class="zhibw">条件2</div>
              <div class="zhibv">里程{{ item.value2 }}万千米以内</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="wuz">
        <img src="../../assets/zhengb.png" alt="" />
        <div>无质保项</div>
      </div>
    </div>
  </div>
</template>
  <script>
// status  2 待复核  3 待归档  4 已完成
// 1 待评估 2待审批 3待归档 4已完成 5已终止
import {
  getVehicleImages_1s,
  getTaskBaseInfo_,
  getVehicleDetail_s,
  getTechAppraisalPre,
  getDetails,
  // } from "@/utils/apicgu.js";
} from "@/utils/http.js";
import { Toast } from "vant";
import { formatDate } from "@/utils/time.js";
export default {
  name: "",
  components: {},
  props: [],
  data() {
    return {
      reviews: "",
      isReviews: "",
      carMessage: [],
      showHistory: false,
      carInfos: {},
      vinContentMessage: "",
      vinInfo: "",
      vinInfos: "",
      vinShow: false,
      numTime: false,
      // 当前页码
      current: 0,
      // 评估基准日展示
      showTime: false,
      // 车系展示
      showSeries: false,
      imgList: [],
      mechanism: false, //评估机构信息
      list: [],
      titleInfo: "",
      msgInfo: "",
      reportInfo: "",
      tips: "",
      paramsList: "",
      proList: [],
    };
  },
  computed: {},
  watch: {
    vinInfo(oldVal, newVal) {
      console.log(newVal);
      console.log(oldVal);
      if (oldVal) {
        this.$nextTick(() => {
          this.$refs.vin.focus();
        });
      }
    },
  },
  created() {
    document.title = "商用车整备服务技术报告";
  },
  mounted() {
    let id = this.$route.query.id;
    // 图片
    this.getImgList(id);
    // 顶部
    this.getList(id);
    // 基本信息
    this.getInfo(id);
    // 报告
    this.getReportInfo(id);
    this.getDetails1(id);
  },
  methods: {
    async getDetails1(id) {
      const { data: res } = await getDetails({ taskId: id });
      this.titleInfo = res.content;
      if (res.content.warranty) {
        this.proList = JSON.parse(res.content.warranty);
      }
    },
    myCopy() {
      const range = document.createRange();
      range.selectNode(document.getElementById("copyInner"));
      const selection = window.getSelection();
      if (selection.rangeCount > 0) selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
      console.log(document.execCommand("copy"));
      if (document.execCommand("copy")) {
        Toast("复制成功");
      }
    },
    formatThousand(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 获取上半部分数据
    async getList(id) {
      return;
      const { data: res } = await getTaskBaseInfo_({ taskId: id });
      // console.log(res);
      this.titleInfo = res.content;
      this.titleInfo.marketFactor = this.titleInfo.marketFactor.toFixed(2);
      this.titleInfo.useFactor = this.titleInfo.useFactor.toFixed(2);
      this.titleInfo.brandFactor = this.titleInfo.brandFactor.toFixed(2);
      this.titleInfo.calculateMileage = this.formatThousand(
        this.titleInfo.calculateMileage
      );
      this.titleInfo.mileage = this.formatThousand(this.titleInfo.mileage);
      let time = this.titleInfo.evaDate.split("-");
      this.titleInfo.evaDate = `${time[0]}年${time[1] - 0}月${time[2] - 0}日`;
    },
    // 获取基本评估数据
    async getInfo(id) {
      //   return;
      const { data: res } = await getVehicleDetail_s({ taskId: id });
      // console.log(res);
      res.content.material.forEach((item) => {
        if (item.name == "基本信息") {
          item.children.forEach((ite) => {
            if (ite.valueType == 6) {
              console.log(ite, "--");
              let time = ite.value.split("-");
              ite.value = `${time[0]}年${time[1] - 0}月${time[2] - 0}日`;
            }
          });
          this.carMessage = item.children;
        }
      });
      this.carMessage.forEach((item) => {
        if (item.fullName == "差异原因") {
          if (!item.value) {
            item.value = "无差异";
          }
        }
      });
      res.content.params.forEach((item) => {
        if (item.name == "其他") {
          this.paramsList = item.children;
        }
      });
    },
    // 获取图片
    async getImgList(id) {
      const { data: res } = await getVehicleImages_1s({ taskId: id });
      let imgList = res.content;
      if (this.$route.query.index) {
        imgList = res.content.filter((item) => {
          if (item.title != "证件") return item;
        });
      }
      imgList.forEach((item, index) => {
        console.log(item);
        item.imgList.forEach((items, ind) => {
          items.index = index;
          this.imgList.push(items);
        });
      });
      console.log(this.imgList);
      this.list = imgList
      this.$store.commit("setImg", imgList);
    },
    // 获取报告
    async getReportInfo(id) {
      const { data: res } = await getTechAppraisalPre({ id: id });
      this.tips = res.content.pop();
      res.content.forEach((item) => {
        if (item.children.length) {
          item.num = item.children.length;
        }
      });
      this.reportInfo = res.content;
      console.log(this.reportInfo, "=====");
      this.$store.commit("setReport", res.content);
    },
    // 轮播图事件
    onChange(index) {
      this.current = index;
    },
    // 查看基本信息页面
    jumpInfo() {
      this.$router.push({
        path: `/restoreMsg`,
        query: {
          id: this.$route.query.id,
        },
      });
    },
    // 查看详细报告
    jumpReport(id) {
      // console.log(id);
      if (id !== "无") {
        this.$router.push({
          path: "/restoreCheck",
          query: { id: id, ids: this.$route.query.id },
        });
      } else {
        this.$router.push({
          path: "/restoreCheck",
          query: { id: id, ids: this.$route.query.id },
        });
      }
    },
    lookAllsw(ite) {
      let data = { id: ite.index, name: ite.value };
      console.log(data);
      this.$store.commit("setImgKey", data);
      this.$router.push("/swiper");
    },
    lookAlls(item) {
      let data = { id: item.imgList[0].index, name: item.imgList[0].value };
      console.log(data);
      this.$store.commit("setImgKey", data);
      this.$router.push("/swiper");
    },
    jumpEav() {
      this.$router.push({
        path: "/eva",
        query: {
          certId: this.titleInfo.certId,
          key: 1,
        },
      });
    },
    jumpDefaultEav() {
      this.$router.push("/defaultEva");
    },
    lookVinInfo() {
      this.vinShow = true;
      this.vinInfo = "";
      this.vinInfos = "";
      this.vinContentMessage = "";
      this.$nextTick(() => {
        this.$refs.vins.focus();
      });
    },
  },
};
</script>
  <style lang='less'  scoped>
.container {
  background: #f8f8f8;
  font-family: PingFangSC-Medium, PingFang SC;
  padding-bottom: 20px;
}

.img {
  width: 100vw;
  height: 211px;
  background: #ffdfdf;
}

.img > .van-image {
  width: 100vw;
  height: 100%;
}

.custom-indicator {
  position: absolute;
  width: 42px;
  height: 16px;
  right: 15px;
  bottom: 15px;
  font-size: 12px;
  text-align: center;
  line-height: 16px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 16px;
}

.title {
  width: 92%;
  height: 80px;
  background-image: url("../../assets/report/title.png");
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 10px;
}

.title-n {
  display: flex;
  font-size: 16px;
  color: #ffffff;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 12px;
}

.reset {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  font-size: 11px;
  width: 130px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
  margin-left: 2px;
  margin-top: 5px;
}

.timer {
  font-size: 12px;
  color: #c9c9c9;
  // width: 150px;
}

.t-top {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.timer-t {
  width: 100px;
  text-align: center;
}

.successIcon {
  position: absolute;
  right: 15px;
  top: 170px;
  height: 64px;
  width: 64px;
}

.day {
  display: flex;
  align-items: center;
  // min-width: 150px;
  min-width: 100px;
  margin-bottom: 5px;
}

.day > img {
  width: 12px;
  height: 12px;
  margin-left: 2px;
}

.m-tip {
  font-size: 13px;
}

.m-num {
  font-size: 20px;
}

.m-let {
  font-size: 13px;
}

.carmsg {
  width: 96%;
  margin: 0 auto;
  margin-top: 10px;
}

.carName {
  min-height: 48px;
  box-sizing: border-box;
  padding: 12px;
  font-size: 17px;
  word-break: break-all;
  word-wrap: break-word;
  line-height: 20px;
  background: #ffffff;
  border-radius: 5px;
}

.vin {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 6px;
}

.newList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  height: 180px;
}

.newList > li {
  width: 48%;
  height: 80px;
  background: #ffffff;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.newList > li img {
  width: 13px;
  height: 13px;
  margin-left: 3px;
  margin-top: -1px;
}

.newList > li > div:nth-of-type(1) {
  font-size: 18px;
  font-family: DINPro-Bold, DINPro;
  font-weight: bold;
  color: #333333;
}

.newList > li > div:nth-of-type(2) {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #818181;
  margin-top: 10px;
}

.series {
  height: 34px;
  background: linear-gradient(180deg, #f3f7ff 0%, #ffffff 100%);
  border-radius: 7px 7px 0px 0px;
  display: flex;
  align-items: center;
}

.series > div {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-left: 12px;
}

.series > img {
  width: 13px;
  height: 13px;
  margin-left: 5px;
}

.changeNumber {
  background: #ffffff;
  height: 80px;
  display: flex;
  color: #666666;
  // color: rgb(215 215 215);
  font-size: 13px;
  font-weight: 400;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  justify-content: space-around;
}

.changeNumber > li {
  width: 108px;
  text-align: center;
}

.changeNumber > li > div:nth-of-type(1) {
  font-size: 18px;
  color: #333333;
  font-weight: 500;
  margin-bottom: 6px;
}

.changeNumber > li {
  width: 108px;
  text-align: center;
}

.changeNumber > .lines {
  width: 0px;
  height: 35px;
  border-left: 1px solid #e6e6e6;
}

.mechanism {
  width: 96%;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 10px;
  padding-bottom: 14px;
}

.m-title {
  height: 65px;
  background-image: url("../../assets/report/background.png");
  background-size: 100% 100%;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  box-sizing: border-box;
  padding-top: 5px;
}

.m-title > div:nth-of-type(1) {
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  padding: 0 12px;
  font-weight: 500;
}

.m-title > div:nth-of-type(2) {
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  height: 20px;
  line-height: 20px;
}

.m-content {
  /* display: flex; */
  // margin-top: 10px;
  margin-left: 12px;
  padding-top: 10px;
}

.m-content > li {
  display: flex;
  color: #333333;
  min-height: 30px;
  // align-items: center;
  font-size: 16px;
  margin: 10px 0;
}

.m-content > li > div:nth-of-type(1) {
  width: 82px;
  font-weight: 400;
}

.m-content > li > div:nth-of-type(2) {
  font-weight: 500;
  margin-left: 10px;
}

.m-tips {
  display: flex;
  justify-content: space-between;
}

.m-before {
  font-size: 16px;
  font-weight: 600;
  text-indent: 12px;
  margin-top: 12px;
}

.m-be-c {
  box-sizing: border-box;
  padding: 12px;
  font-size: 14px;
  line-height: 18px;
}

.m-be-c > span {
  font-weight: bold;
}

.m-be-tip {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
  padding-bottom: 10px;
}

.m-be-tip > li {
  min-height: 20px;
  line-height: 22px;
  box-sizing: border-box;
  padding: 0 10px;
}

.showMechanism {
  text-align: center;
  font-size: 14px;
  color: #999999;
  margin-top: 12px;
}

.showMechanism > span {
  margin-right: 4px;
}

.checkInfo {
  width: 96%;
  margin: 10px auto;
  min-height: 200px;
  background: #ffffff;
  border-radius: 7px;
  box-sizing: border-box;
  padding: 12px;
}

.ckLines {
  display: flex;
  margin-top: 12px;
}

.ckLines-l {
  margin-top: 24px;
}

.ckLines-l > li:nth-of-type(1) {
  width: 7px;
  height: 7px;
  background: #c5deff;
}

.ckLines-l > li:nth-of-type(2) {
  width: 1px;
  height: 70px;
  border-left: 2px dashed #c5deff;
  margin-left: 3px;
}

.ckLines-l > li:nth-of-type(3) {
  width: 6px;
  height: 6px;
  border: 1px solid #c5deff;
}

.cklInfo {
  margin-left: 10px;
  flex: 1;
}

.cklInfo > ul:nth-of-type(2) {
  margin-top: 22px;
}

.imgMsg {
  display: flex;
}

.imgMsg img {
  width: 40px;
  height: 54px;
}

.msg-t {
  flex: 1;
  box-sizing: border-box;
  padding: 8px;
}

.msg-t > div:nth-of-type(2) {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  margin-top: 14px;
}

.msg-time {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a3a3a3;
}

.msg-time > div:nth-of-type(1) {
  font-size: 14px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #333333;
}

.appraiser {
  width: 96%;
  height: 50px;
  background-image: url("../../assets/report/people.png");
  background-size: 100% 100%;
  //   margin: 0 auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;
  margin: 10px auto;
}

.logo {
  display: flex;
  align-items: center;
}

.logo > .van-image {
  width: 26px;
  height: 26px;
  // border-radius: 50%;
  margin-right: 10px;
  // border: 1px solid #5ea7ff;
}

/deep/ .logo > .van-image > img {
  border-radius: 50%;
  // margin-right: 10px;
  border: 1px solid #5ea7ff;
}

.a-name {
  color: #333333;
  font-size: 14px;
  font-weight: 400;
}

.a-title-img {
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-left: 12px;
}

.a-title {
  display: flex;
}

.a-title > img {
  width: 13px;
  height: 11px;
  margin-right: 4px;
  margin-top: 2px;
}

.a-link {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  text-align: center;
}

.car-name {
  background: linear-gradient(180deg, #e7f0ff 0%, #ffffff 100%);
  border-radius: 7px 7px 0px 0px;
  /* padding: 0; */
  height: 77px;
  width: 96%;
  margin: 0 auto;
  margin-top: 10px;
  border-bottom: 1px solid #f5f5f5;
}

.appInfo {
  width: 96%;
  margin: 0 auto;
  background: #ffffff;
  padding-bottom: 10px;
  border-radius: 7px;
}

.carMoreInfo {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  padding: 15px 0 0px 11px;
}

.app-list {
  box-sizing: border-box;
  padding: 15px;
  padding-top: 10px;
}

.app-item {
  display: flex;
  font-size: 13px;
  color: #666666;
  align-items: center;
  height: 30px;
}

.app-times > div:nth-of-type(1) {
  font-size: 13px;
  color: #666666;
}

.app-times > div:nth-of-type(2) {
  font-size: 14px;
  color: #333333;
  margin-top: 5px;
}

.app-item > div:nth-of-type(1) {
  width: 95px;
  margin-right: 4px;
}

.app-item > div:nth-of-type(2) {
  font-size: 14px;
  color: #333333;
}

.app-time > div:nth-of-type(1) {
  width: 180px;
}

.app-tip {
  font-size: 14px;
  line-height: 20px;
  /* margin-top: 10px; */
}

.lookMsg {
  width: 230px;
  height: 36px;
  background: #f4f8ff;
  line-height: 36px;
  text-align: center;
  margin: 0 auto;
  font-size: 14px;
  color: #333333;
  margin-bottom: 10px;
}

.showTimeTitle {
  font-size: 19px;
  text-align: center;
  padding-top: 12px;
  line-height: 30px;
}

.showTimeTitle1 {
  font-size: 19px;
  color: #333333;
  font-weight: bold;
}

.showTimeTip {
  width: 95%;
  margin: 0 auto;
  font-size: 12px;
  word-break: break-all;
  word-wrap: break-word;
  margin-top: 5px;
  line-height: 18px;
}

.showTimeTip1 {
  width: 90%;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
  padding-bottom: 10px;
  color: #333333;
}

.showSeries {
  width: 90%;
  margin: 0 auto;
}

.carImgTitle {
  width: 95%;
  margin: 0 auto;
  height: 48px;
  background: linear-gradient(180deg, #e7f0ff 0%, #ffffff 100%);
  border-radius: 7px 7px 0px 0px;
  line-height: 48px;
  text-indent: 12px;
  margin-top: 10px;
  font-size: 19px;
}

.showSeries {
  margin-top: 10px;
}

.showSeriesT {
  font-size: 17px;
  font-weight: bold;
  color: #333333;
  margin: 8px 0;
}

.showSeriesTs {
  margin-top: 15px;
}

.showSeriesTe {
  font-size: 14px;
  line-height: 18px;
}

.showSeriesTd {
  padding-top: 5px;
}

.showSeriesD {
  margin: 5px 0;
  font-size: 14px;
}

.showSeriesD > span:nth-of-type(1) {
  font-weight: bold;
  color: #333333;
}

.cag-c {
  background: #ffffff;
  width: 95%;
  margin: 0 auto;
  overflow: hidden;
}

.carimg-nav {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 12px;
  color: #333333;
  font-size: 17px;
}

.ca-more {
  font-size: 14px;
  color: #666666;
}

.carI-list {
  height: 105px;
  display: flex;
  overflow-x: auto;
  padding-bottom: 10px;
}

.carI-list::-webkit-scrollbar {
  display: none;
}

.carI-list > li {
  width: 142px;
  height: 106px;
  margin-left: 10px;
  position: relative;
}

.play {
  width: 25px;
  height: 25px;
  position: absolute;
  top: 30px;
  left: 60px;
}

.plays {
  width: 50px;
  height: 50px;
  top: 80px;
  left: 164px;
}

.play > img {
  width: 100%;
  height: 100%;
}

.carI-list > li:nth-of-type(1) {
  margin-left: 12px;
}

.carI-list > li:last-child {
  margin-right: 12px;
}

.carI-list > li > .van-image {
  width: 142px;
  height: 106px;
}

.carI-list > li > video {
  width: 142px;
  height: 106px;
}

/deep/ .carI-list > li > .van-image > img {
  border-radius: 3px;
}

.imgName {
  width: 100%;
  height: 23px;
  position: absolute;
  bottom: 0;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 23px;
  color: #ffffff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  padding: 0 10px;
  // background: linear-gradient(180deg, rgba(238, 238, 238, 0) 0%, #000000 100%);
  border-radius: 0px 0px 3px 3px;
  background-image: url("https://vehicle-library.oss-cn-beijing.aliyuncs.com/cvbd-icon/gradient_background.png");
  background-size: 100% 100%;
}

.car-report {
  width: 95%;
  margin: 0 auto;
  background: #ffffff;
  padding-bottom: 10px;
}

.c-p {
  width: 100%;
}

.c-p-n {
  /* width: 100%; */
  background-image: url("../../assets/report/number.png");
  background-size: 100% 100%;
}

.c-p-n > li > div:nth-of-type(1) {
  color: #ffffff;
  margin-bottom: 10px;
}

.c-p-n > .lines {
  border-left: 1px solid #505050;
}

.report-list {
  box-sizing: border-box;
  padding: 0 12px;
  /* margin-top: 13px; */
}

.report-list-item:nth-of-type(1) {
  font-size: 16px;
  height: 50px;
}

.report-list-item:nth-of-type(1) > .report-bug {
  display: block;
}

.report-list-item > div:nth-of-type(1) {
  font-size: 16px;
}

.report-list-item {
  display: flex;
  min-height: 32px;
  justify-content: space-between;
  align-items: center;
}

.report-name {
  width: 110px;
  line-height: 20px;
}

.report-number,
.report-bug {
  width: 75px;
  font-size: 14px;
}

.report-level {
  width: 40px;
  font-size: 14px;
}

.report-bug {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding-right: 10px;
}

.report-bug > div {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  color: #ffffff;
}

.report-bug > .error {
  background: #f9702b;
}

.report-bug > .success {
  background: #5edb7b;
}

.look-report {
  margin-top: 10px;
}

.impairmentItem {
  width: 95%;
  margin: 0 auto;
  background: #ffffff;
  padding-bottom: 10px;
}

.im-nav {
  box-sizing: border-box;
  padding: 0 12px;
}

.im-item {
  display: flex;
  justify-content: space-between;
  min-height: 40px;
  align-items: center;
  border-top: 1px solid #eeeeee;
  font-size: 15px;
}

.im-items {
  border: none;
}

.im-title {
  background: #f6f6f6;
  box-sizing: border-box;
  padding: 0 12px;
}

.im-top {
  border-top: 1px solid #eeeeee;
}

.im-mark {
  padding: 0 12px;
  color: #666666;
  justify-content: space-between;
}

.im-mark > div:nth-of-type(1) {
  width: 130px;
}

.im-img {
  border-top: 1px solid #cdcdcd;
  display: flex;
  box-sizing: border-box;
  padding: 0 12px;
  height: 90px;
  align-items: center;
}

.im-img-item {
  width: 65px;
  height: 65px;
  margin-right: 10px;
}

.im-img-item > .van-image {
  width: 100%;
  height: 100%;
}

/deep/ .im-img-item > .van-image > img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.im-msg {
  line-height: 15px;
  min-height: 41px;
}

.specialTip,
.taskBox {
  width: 95%;
  margin: 0 auto;
}

.specialTip {
  width: 96%;
  border-radius: 5px;
}

.sp-tips {
  box-sizing: border-box;
  padding: 12px;
  background: #ffffff;
  min-height: 40px;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  padding-top: 0;
}

/deep/ .van-popup {
  border-radius: 5px;
}

/deep/ .dayDia > .van-popup {
  width: 270px;
  min-height: 140px;
}

/deep/ .dayDia > .van-popup__close-icon--top-right {
  top: 0px !important;
  right: 0;
}

/deep/ .numDia > .van-popup {
  width: 250px;
  height: 100px;
}

/deep/ .serDia > .van-popup {
  width: 300px;
  min-height: 350px;
}

.Ntips {
  font-size: 16px;
  margin-top: 14px;
  text-align: center;
}

.app-item-img {
  display: flex;
  align-items: center;
}

.app-item-img img {
  width: 14px;
  height: 14px;
  margin-left: 6px;
}

.logo-tips {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0266e6;
}

.m-tips-content {
  width: 240px;
  word-break: break-all;
  word-wrap: break-word;
  line-height: 22px;
}

.im-item > div:nth-of-type(2) {
  width: 200px;
  word-break: break-all;
  word-wrap: break-word;
  line-height: 22px;
  text-align: right;
}

.lookVinInfo {
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0266e6;
  line-height: 40px;
  margin-left: 50px;
}

.vinDataTitle {
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  border: 1px solid #f3f3f3;
}

.info_ul {
  display: flex;
  margin-top: 40px;
  box-sizing: border-box;
  padding: 0 36px;
  font-size: 22px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #333333;
  align-items: center;
}

.enterTxt {
  width: 40px;
  height: 40px;
  background: #edf5ff;
  border-radius: 4px;
  margin: 0 10px;
}

.enterTxt > input {
  width: 100%;
  height: 100%;
  background: #edf5ff;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 10px;
}

.vinTips {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-top: 15px;
  text-align: center;
}

.submitVin {
  width: 240px;
  line-height: 40px;
  background: linear-gradient(214deg, #059ff4 0%, #0266e6 100%);
  box-shadow: 0px 2px 6px 0px #0266e6;
  border-radius: 5px;
  margin: 20px auto;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
}

.vinMessage {
  font-size: 22px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin: 50px 0;
}

.taskBox {
  height: 140px;
  background: #ffffff;
  border-radius: 7px;
  box-sizing: border-box;
  padding: 15px;
  margin-top: 10px;
}

.taskBox > div {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}

.taskUl {
  margin-top: 20px;
}

.taskUl > li {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.operation {
  width: 100%;
  display: flex;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(213, 213, 213, 0.5);
  align-items: center;
}

.operation > div {
  width: 70px;
  height: 36px;
  background: #f2f2f2;
  border-radius: 5px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
}

.showTimeTips {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
  box-sizing: border-box;
  padding: 5px 15px;
  line-height: 22px;
}

.shoHis {
  width: 180px;
  line-height: 38px;
  background: linear-gradient(214deg, #059ff4 0%, #0266e6 100%);
  box-shadow: 0px 1px 4px 0px #79b4ff;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin: 20px auto;
}

.report-names {
  height: 44px;
  display: flex;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  justify-content: space-between;
  align-items: center;
}

.report-bug {
  margin: 0;
}

.report-cs {
  height: 38px;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  box-sizing: border-box;
  padding: 0 10px;
}

.report-list > li {
  border-bottom: 1px solid #ebebeb;
  //   padding-bottom: 16px;
}

.report-list > li:nth-of-type(1) {
  border-top: 1px solid #ebebeb;
  //   margin-top: 15px;
}

.sub-d {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff3b3b;
  margin-top: 13px;
}

.lookMsgss {
  margin-top: 15px;
}

.app-item-f {
  display: block;
  margin-top: 5px;
}

.app-item-f > div:nth-of-type(2) {
  margin-top: 10px;
}

.lookMsg {
  margin-top: 10px;
}

.Usage {
  width: 96%;
  min-height: 124px;
  border-radius: 5px;
  background: #ffffff;
  margin: 10px auto;
  box-sizing: border-box;
  padding: 15px 12px;
}

.u-t {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}

.u-li {
  margin-top: 20px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.u-li > span:nth-of-type(2) {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 20px;
}

#u-l-s {
  margin-left: 46px;
}

.successIcons {
  top: 20px;
  left: 60px;
}

.checkInfo-t {
  font-size: 19px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.pops {
  font-size: 14px;
  color: #666666;
}
.ans {
  width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.restore {
  display: flex;
}
.restore > div:nth-of-type(1) {
  margin-right: 4px;
}
.restore-num {
  font-weight: 400;
  font-size: 14px;
  color: #e60000;
}
.bottoms {
  width: 95%;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 10px;
  box-sizing: border-box;
  padding: 10px 12px;
  font-family: PingFangSC, PingFang SC;
  border-radius: 7px;
}
.b-title {
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  margin-bottom: 14px;
}
.b-tip {
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
}
.zhibao {
  //   width: 321px;
  background: #f8f8f8;
  border-radius: 4px;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  box-sizing: border-box;
  padding: 10px;
  font-family: PingFangSC, PingFang SC;
  margin-top: 10px;
}
.zhibao > div:nth-of-type(1) {
  margin-bottom: 14px;
  display: flex;
}
.tiaojian {
  display: flex;
  font-size: 14px;
  align-items: center;
}
.zhibw {
  width: 63px;
  text-align: right;
  margin-right: 10px;
}
.tiaojian1 {
  margin-top: 9px;
}
.zhibv {
  width: 237px;
  height: 25px;
  border-radius: 2px;
  border: 1px solid #979797;
  text-indent: 8px;
  line-height: 25px;
  // color: #666666;
}
.wuz {
  //   width: 321px;
  height: 150px;
  font-family: PingFangSC, PingFang SC;
  background: #f8f8f8;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  padding: 20px 0;
  font-weight: 400;
  font-size: 15px;
  color: #666666;
  margin-top: 10px;
}
.wuz img {
  width: 76px;
  height: 78px;
  margin-bottom: 10px;
}
</style>